module.exports = __webpack_public_path__ + "img/122.3ec3dd35.png";